/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Navbar from "../../components/Navbar";
import Sidebar from "../../components/Sidebar";
import { toast, Toaster } from "react-hot-toast";
import axios from "axios";
import Notice from "../../components/Notice";
import Student from "./Student";
import Faculty from "./Faculty";
import Subjects from "./Subject";
import { baseApiURL } from "../../baseUrl";
import Admin from "./Admin";
import Profile from "./Profile";
import Branch from "./Branch";
import Attendance from "./Attendence";
import Library from "./Library";
import TransportIncharge from "./TransportIncharge";
import HostelIncharge from "./HostelIncharge";
import Section from "./Section";
import Timetables from "./Timetables";
import Reports from "./Reports";
import OBEConfig from "./OBE/OBEConfig";
import OBEReports from "./OBE/OBEReports";
import GeofenceSetup from "./GeofenceSetup";
import DailyFacultyAttendance from "./DailyFacultyAttendance";
import AIAnalytics from "./AIAnalytics";
import NotificationSettings from "./NotificationSettings";
import MessageParent from "../../components/MessageParent";
import PredictiveAnalytics from "./PredictiveAnalytics";
import NoticeTicker from "../../components/NoticeTicker";

const Home = () => {
  const router = useLocation();
  const navigate = useNavigate();
  const [load, setLoad] = useState(false);
  const [selectedMenu, setSelectedMenu] = useState("Profile");
  const [isSidebarCollapsed, setIsSidebarCollapsed] = useState(false);
  const [targetRollNo, setTargetRollNo] = useState("");
  const [dashboardData, setDashboardData] = useState({
    studentCount: "",
    facultyCount: "",
  });

  useEffect(() => {
    const activeToken = localStorage.getItem("token");
    if (router.state === null && !activeToken) {
      navigate("/");
    }
    setLoad(true);

    // Listen for navbar profile click
    const handleOpenProfile = () => setSelectedMenu("Profile");
    window.addEventListener("openProfile", handleOpenProfile);
    return () => window.removeEventListener("openProfile", handleOpenProfile);
  }, [navigate, router.state]);

  useEffect(() => {
    getStudentCount();
    getFacultyCount();
  }, []);

  const getStudentCount = () => {
    const headers = {
      "Content-Type": "application/json",
    };
    axios
      .get(`${baseApiURL()}/student/details/count`, {
        headers: headers,
      })
      .then((response) => {
        if (response.data.success) {
          setDashboardData((prev) => ({
            ...prev,
            studentCount: response.data.user,
          }));
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const getFacultyCount = () => {
    const headers = {
      "Content-Type": "application/json",
    };
    axios
      .get(`${baseApiURL()}/faculty/details/count`, {
        headers: headers,
      })
      .then((response) => {
        if (response.data.success) {
          setDashboardData((prev) => ({
            ...prev,
            facultyCount: response.data.user,
          }));
        } else {
          toast.error(response.data.message);
        }
      })
      .catch((error) => {
        console.error(error);
      });
  };

  const renderContent = () => {
    switch (selectedMenu) {
      case "Profile":
        return <Profile />;
      case "Student":
        return <Student onMessageParent={(roll) => { setTargetRollNo(roll); setSelectedMenu("Message Parent"); }} />;
      case "Faculty":
        return <Faculty />;
      case "Branch":
        return <Branch />;
      case "Notice":
        return <Notice />;
      case "Message Parent":
        return <MessageParent userType="Admin" currentUser={router.state} initialEnrollmentNo={targetRollNo} />;
      case "Subjects":
        return <Subjects />;
      case "Timetables":
        return <Timetables />;
      case "Attendance":
        return <Attendance />;
      case "Admin":
        return <Admin />;
      case "Library":
        return <Library />;
      case "Transport Incharge":
        return <TransportIncharge />;
      case "Hostel Incharge":
        return <HostelIncharge />;
      case "Section":
        return <Section />;
      case "Reports":
        return <Reports />;
      case "OBE Config":
        return <OBEConfig />;
      case "OBE Reports":
        return <OBEReports />;
      case "GeofenceSetup":
        return <GeofenceSetup />;
      case "DailyFacultyAttendance":
        return <DailyFacultyAttendance />;
      case "AI Analytics":
        return <AIAnalytics />;
      case "PredictiveAnalytics":
        return <PredictiveAnalytics />;
      case "Notification Settings":
        return <NotificationSettings />;
      default:
        return <Profile />;
    }
  };

  return (
    <>
      {load && (
        <div className="min-h-screen bg-slate-50 dark:bg-slate-950 text-slate-900 dark:text-slate-100 transition-colors duration-250">
          <Navbar />
          <Sidebar 
            selectedMenu={selectedMenu} 
            setSelectedMenu={setSelectedMenu} 
            userType="Admin" 
            isCollapsed={isSidebarCollapsed} 
            setIsCollapsed={setIsSidebarCollapsed}
          />
          
          {/* Main Content Area */}
          <div className={`transition-all duration-300 ${isSidebarCollapsed ? "md:ml-16 w-full md:w-[calc(100%-4rem)]" : "md:ml-64 w-full md:w-[calc(100%-16rem)]"} ml-0 min-h-[calc(100vh-4rem)]`}>
            <div className="p-4 md:p-6 lg:p-8 w-full space-y-6">
              {/* Bento Dashboard Section */}
              {selectedMenu === "Profile" && (
                <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-4 md:gap-6">
                  
                  {/* Hero Bento Box (Spans 2 columns) */}
                  <div className="md:col-span-2 lg:col-span-2 rounded-2xl bg-white dark:bg-slate-900 p-6 text-slate-900 dark:text-white relative overflow-hidden flex flex-col justify-between min-h-[180px] border border-slate-200 dark:border-slate-800 shadow-xs dark:shadow-xl">
                    <div>
                      <span className="inline-flex items-center px-3 py-1 rounded-full text-xs font-bold bg-indigo-50 dark:bg-indigo-500/20 text-indigo-600 dark:text-indigo-300 border border-indigo-100 dark:border-indigo-500/40 mb-3 shadow-xs">
                        <span className="w-2 h-2 rounded-full bg-emerald-500 dark:bg-emerald-400 mr-2 animate-pulse"></span>
                        Admin Control Panel
                      </span>
                      <h1 className="text-xl md:text-2xl font-black tracking-tight">Sphoorthy Engineering College</h1>
                      <p className="text-slate-500 dark:text-slate-400 text-xs md:text-sm font-semibold mt-1">Autonomous Academic & Campus Management System</p>
                    </div>
                    <div className="flex flex-wrap items-center space-x-3 pt-4 border-t border-slate-200 dark:border-slate-800 mt-4 text-xs font-semibold text-slate-600 dark:text-slate-300">
                      <span className="text-slate-400">Quick Navigation</span>
                      <span className="text-slate-400">•</span>
                      <button onClick={() => setSelectedMenu("Student")} className="text-indigo-600 dark:text-indigo-400 hover:underline transition-colors cursor-pointer font-bold">Students</button>
                      <span className="text-slate-400">•</span>
                      <button onClick={() => setSelectedMenu("Faculty")} className="text-indigo-600 dark:text-indigo-400 hover:underline transition-colors cursor-pointer font-bold">Faculty</button>
                    </div>
                  </div>

                  {/* Student Count Card */}
                  <div 
                    onClick={() => setSelectedMenu("Student")}
                    className="rounded-2xl p-5 flex flex-col justify-between bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 shadow-xs dark:shadow-md hover:border-emerald-500/50 cursor-pointer transition-all"
                  >
                    <div className="flex items-center justify-between">
                      <span className="text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Students</span>
                      <div className="w-9 h-9 bg-emerald-50 dark:bg-emerald-500/10 rounded-xl flex items-center justify-center text-emerald-600 dark:text-emerald-400 border border-emerald-100 dark:border-emerald-500/20">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4.354a4 4 0 110 5.292M15 21H3v-1a6 6 0 0112 0v1zm0 0h6v-1a6 6 0 00-9-5.197M13 7a4 4 0 11-8 0 4 4 0 018 0z" />
                        </svg>
                      </div>
                    </div>
                    <div className="mt-4">
                      <p className="text-3xl font-black text-slate-900 dark:text-white">{dashboardData.studentCount || "0"}</p>
                      <p className="text-[11px] text-emerald-600 dark:text-emerald-400 font-medium mt-1">✓ Active Registrations</p>
                    </div>
                  </div>

                  {/* Faculty Count Card */}
                  <div 
                    onClick={() => setSelectedMenu("Faculty")}
                    className="rounded-2xl p-5 flex flex-col justify-between bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 shadow-xs dark:shadow-md hover:border-purple-500/50 cursor-pointer transition-all"
                  >
                    <div className="flex items-center justify-between">
                      <span className="text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Faculty</span>
                      <div className="w-9 h-9 bg-purple-50 dark:bg-purple-500/10 rounded-xl flex items-center justify-center text-purple-600 dark:text-purple-400 border border-purple-100 dark:border-purple-500/20">
                        <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 13.255A23.931 23.931 0 0112 15c-3.183 0-6.22-.62-9-1.745M16 6V4a2 2 0 00-2-2h-4a2 2 0 00-2 2v2m4 6h.01M5 20h14a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" />
                        </svg>
                      </div>
                    </div>
                    <div className="mt-4">
                      <p className="text-3xl font-black text-slate-900 dark:text-white">{dashboardData.facultyCount || "0"}</p>
                      <p className="text-[11px] text-purple-600 dark:text-purple-400 font-medium mt-1">✓ Teaching Faculty</p>
                    </div>
                  </div>
                </div>
              )}

              {/* Main Content Render */}
              <div className="w-full">
                {renderContent()}
              </div>

            </div>
          </div>
        </div>
      )}
      <Toaster position="top-center" />
    </>
  );
};

export default Home;
